export default "__VITE_ASSET__d68e87df__"